import { css } from 'astroturf';
import React from 'react';

const styles = css`
  .trustsection {
    max-width: 1200px;
    margin: 2rem auto 4rem;
    padding:0 1rem;

    h3 {
      margin-bottom: 1rem;
    }
  }

  .trustgrid {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 12px;
  }

  .trustitem {
    display: flex;
    flex-direction: column;
    gap: 0;
    align-items: center;
    max-width: 15rem;
    flex: 1 1 120px;
  }

  .trusticon {
    flex: 0 0 auto;
    display: grid;
    place-items: center;
  }

  .trusticon svg {
    width: 26px;
    height: 26px;
    stroke: #1788d8;
    stroke-width: 1.8;
    stroke-linecap: round;
    stroke-linejoin: round;
    fill: none;
  }

  .trustitem h3 {
    margin: 0;
    font-size: 1rem;
    color: #0f172a;
  }

  .trustitem p {
    margin: 0;
    color: #667085;
    line-height: 1.5;
    font-size: 0.895rem;
    text-wrap: balance;
  }
`;

const Trust = () => {
  const nope = '';

  return (
    <section className={styles.trustsection}>
      <div className={styles.trustgrid}>
        <article className={styles.trustitem}>
          <div className={styles.trusticon}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-credit-card"
            >
              <path d="M3 8a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3l0 -8" />
              <path d="M3 10l18 0" />
              <path d="M7 15l.01 0" />
              <path d="M11 15l2 0" />
            </svg>
          </div>

          <h3>Credit card-free trial</h3>

          <p>Try it for free, no automatic subscription.</p>
        </article>

        <article className={styles.trustitem}>
          <div className={styles.trusticon}>
            <svg viewBox="0 0 24 24">
              <circle cx="12" cy="12" r="9" />
              <line x1="10" y1="8" x2="10" y2="16" />
              <line x1="14" y1="8" x2="14" y2="16" />
            </svg>
          </div>

          <h3>Pause anytime</h3>

          <p>Taking a break? Pause renewals instead of cancelling.</p>
        </article>

        <article className={styles.trustitem}>
          <div className={styles.trusticon}>
            <svg viewBox="0 0 24 24">
              <path d="M12 4a4 4 0 0 1 4 4v4l2 3H6l2-3V8a4 4 0 0 1 4-4" />
              <path d="M10 18a2 2 0 0 0 4 0" />
            </svg>
          </div>

          <h3>Renewal reminders</h3>

          <p>You'll always get a reminder before your subscription renews.</p>
        </article>

        <article className={styles.trustitem}>
          <div className={styles.trusticon}>
            <svg viewBox="0 0 24 24">
              <path d="M5 13v-1a7 7 0 0 1 14 0v1" />
              <rect x="4" y="12" width="3" height="6" rx="1" />
              <rect x="17" y="12" width="3" height="6" rx="1" />
              <path d="M20 18c0 2-2 3-5 3" />
            </svg>
          </div>

          <h3>Human support</h3>

          <p>Talk directly to the person building Polypane.</p>
        </article>

        <article className={styles.trustitem}>
          <div className={styles.trusticon}>
            <svg viewBox="0 0 24 24">
              <path d="M12 3l7 3v5c0 5-3 8-7 10-4-2-7-5-7-10V6z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </div>

          <h3>Private by default</h3>

          <p>Everything is local, and we never see your data.</p>
        </article>

        <article className={styles.trustitem}>
          <div className={styles.trusticon}>
            <svg viewBox="0 0 24 24">
              <rect x="3" y="4" width="18" height="12" rx="2" />
              <line x1="12" y1="16" x2="12" y2="20" />
              <line x1="8" y1="20" x2="16" y2="20" />
            </svg>
          </div>

          <h3>Windows, Mac, Linux</h3>

          <p>Works across all three operating systems.</p>
        </article>
      </div>
    </section>
  );
};

export default Trust;
